var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { height: "auto" } },
    [
      _c("my-asidebar", { attrs: { "active-tab": "reports" } }),
      _vm._v(" "),
      _c(
        "section",
        { staticClass: "dashboard-area" },
        [
          _c("top-bar"),
          _vm._v(" "),
          _c("button", { on: { click: _vm.saveDesign } }, [
            _vm._v("Save Design"),
          ]),
          _vm._v(" "),
          _c("button", { on: { click: _vm.exportHtml } }, [
            _vm._v("Export HTML"),
          ]),
          _vm._v(" "),
          _c("EmailEditor", {
            ref: "emailEditor",
            attrs: {
              height: "500px",
              "min-height": 1000,
              appearance:
                "{\n              theme: 'dark',\n          panels: {\n          tools: {\n          dock: 'right',\n          },\n          },\n          }",
            },
            on: { load: _vm.editorLoaded, ready: _vm.editorReady },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }